module.exports = __webpack_public_path__ + "201811/img/sale_item.0a618f31.png";